
import Navbar from '../../home/components/Navbar';
import Footer from '../../home/components/Footer';
import {
  ServicePageHero,
  ServiceProcess,
  ServiceTrust,
  ServiceContact,
} from '../../../components/feature';
import { SEWAGE_CLEANUP_DATA, SERVICE_FORM_ENDPOINT } from '../../../data/servicePageData';

export default function SewageCleanupPage() {
  const { title, subtitle, heroImage, processTitle, processSubtitle, steps } = SEWAGE_CLEANUP_DATA;

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <ServicePageHero title={title} subtitle={subtitle} backgroundImage={heroImage} />
      <ServiceProcess title={processTitle} subtitle={processSubtitle} steps={steps} />
      <ServiceTrust serviceName="Sewage Cleanup" />
      <ServiceContact serviceName="Sewage Cleanup" formEndpoint={SERVICE_FORM_ENDPOINT} />
      <Footer />
    </div>
  );
}
